import { createContext, useContext, type ReactNode } from 'react'

export type TranslateFn = (key: string, values?: Record<string, unknown>) => string

const identityTranslator: TranslateFn = (key) => key

const I18nContext = createContext<TranslateFn>(identityTranslator)

export function I18nProvider({ translate, children }: { translate: TranslateFn; children: ReactNode }) {
  return <I18nContext.Provider value={translate}>{children}</I18nContext.Provider>
}

export function useTranslator(): TranslateFn {
  return useContext(I18nContext)
}

export function useT() {
  const t = useTranslator()
  return { t }
}
